module.exports = __webpack_public_path__ + "files/65230bda9b25899f895380efb778c882.png";